import { render, staticRenderFns } from "./ApplicantDetailPreviousDuplicate.vue?vue&type=template&id=9f182fde"
import script from "./ApplicantDetailPreviousDuplicate.vue?vue&type=script&lang=js"
export * from "./ApplicantDetailPreviousDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports